import {
  URL_GENERAL_MANAGMENT_FIJO,
  URL_GENERAL_MANAGMENT_INTERNET,
  URL_GENERAL_MANAGMENT_MOBILE,
  URL_GENERAL_MANAGMENT_MOBILE_BLOQUEOS,
  URL_GENERAL_MANAGMENT_PHONE_BLOQUEOS,
  URL_GENERAL_MANAGMENT_PHONE_MORE_MANAGMENT,
  URL_DETOUR_PHONE_LANDLINE,
  URL_GENERAL_MANAGMENT_MOBILE_IMEI_PUK,
  INTENET,
  MOBILE,
  FIJO,
  URL_GENERAL_MANAGMENT_TV,
  TV,
} from "@/constants/general-managment-constants";
import {
  findPhonesNumbersByProductId,
  generateFullNameDistriProduct,
} from "@/utils/dataHandlers/ProductDataHandler";

export const getAllMobileLines = (hiredProducts) => {
  let mobiles = [];
  if (
    hiredProducts &&
    Array.isArray(hiredProducts) &&
    hiredProducts.length > 0
  ) {
    hiredProducts.map((product) => {
      if (
        product?.mobile?.linesMobile &&
        Array.isArray(product.mobile.linesMobile) &&
        product.mobile.linesMobile.length > 0
      ) {
        product.mobile.linesMobile.map((lineMobile) => {
          mobiles.push({
            productId: lineMobile?.productId,
            number: lineMobile?.number,
            isPrepaid: product.productOfferingTypes.some(({ id }) => id === "6")
              ? true
              : false,
          });
        });
      }
    });
  }
  return mobiles;
};

export const getAllPhoneLines = (hiredProducts) => {
  let phones = [];
  if (
    hiredProducts &&
    Array.isArray(hiredProducts) &&
    hiredProducts.length > 0
  ) {
    hiredProducts.map((product) => {
      if (
        product?.phone?.linesPhone &&
        Array.isArray(product.phone.linesPhone) &&
        product.phone.linesPhone.length > 0
      ) {
        product.phone.linesPhone.map((linePhone) => {
          phones.push({
            productId: linePhone?.productId,
            number: linePhone?.number,
          });
        });
      }
    });
  }
  return phones;
};

export const getAllInternet = (hiredProducts) => {
  let internet = [];
  if (
    hiredProducts &&
    Array.isArray(hiredProducts) &&
    hiredProducts.length > 0
  ) {
    hiredProducts.map((product) => {
      if (product?.internet) {
        const phone = findPhonesNumbersByProductId({
          hiredProducts,
          productId: product.productId,
        });
        const number = generateFullNameDistriProduct({
          name: product.internet.description,
          hiredProducts,
          productId: product.productId,
        });
        internet.push({
          productId: product.internet.productId,
          number,
          phone: phone?.fijo || phone?.mobile,
        });
      }
    });
  }
  return internet;
};

export const getRestrictionFijo = (mobileRestriction, type) => {
  let selectRestriction = "";
  if (mobileRestriction?.groups && Array.isArray(mobileRestriction?.groups)) {
    mobileRestriction?.groups.map((group) => {
      if (group?.restricciones && Array.isArray(group?.restricciones)) {
        group?.restricciones.map((restriccion) => {
          if (restriccion?.idRestriccion === type) {
            selectRestriction = restriccion;
          }
        });
      }
    });
  }
  return selectRestriction;
};

export const getAllTvProducts = (hiredProducts) => {
  let tv = [];
  if (
    hiredProducts &&
    Array.isArray(hiredProducts) &&
    hiredProducts.length > 0
  ) {
    hiredProducts.map((product) => {
      if (product?.tv) {
        tv.push({
          productId: product.tv.productId,
          number: product.tv.description,
          satelite: product.tv?.satelite,
        });
      }
    });
  }
  return tv;
};

export const getProducDatatByType = ({ alias, hiredProducts }) => {
  let products = null;
  switch (alias) {
    case URL_GENERAL_MANAGMENT_FIJO:
      products = getAllPhoneLines(hiredProducts);
      break;
    case URL_GENERAL_MANAGMENT_MOBILE_BLOQUEOS:
      products = getAllMobileLines(hiredProducts);
      break;
    case URL_GENERAL_MANAGMENT_PHONE_BLOQUEOS:
      products = getAllPhoneLines(hiredProducts);
      break;
    case URL_GENERAL_MANAGMENT_PHONE_MORE_MANAGMENT:
      products = getAllPhoneLines(hiredProducts);
      break;
    case URL_DETOUR_PHONE_LANDLINE:
      products = getAllPhoneLines(hiredProducts);
      break;
    case URL_GENERAL_MANAGMENT_MOBILE_IMEI_PUK:
      products = getAllMobileLines(hiredProducts);
      break;
    case URL_GENERAL_MANAGMENT_MOBILE:
      products = getAllMobileLines(hiredProducts);
      break;
    case URL_GENERAL_MANAGMENT_INTERNET:
      products = getAllInternet(hiredProducts);
      break;
    case URL_GENERAL_MANAGMENT_TV:
      products = getAllTvProducts(hiredProducts);
  }
  return products;
};

export const getManagamnetType = ({ alias }) => {
  let type = null;
  switch (alias) {
    case URL_GENERAL_MANAGMENT_FIJO:
      type = FIJO;
      break;
    case URL_GENERAL_MANAGMENT_PHONE_BLOQUEOS:
      type = FIJO;
      break;
    case URL_GENERAL_MANAGMENT_PHONE_MORE_MANAGMENT:
      type = FIJO;
      break;
    case URL_DETOUR_PHONE_LANDLINE:
      type = FIJO;
      break;
    case URL_GENERAL_MANAGMENT_MOBILE:
      type = MOBILE;
      break;
    case URL_GENERAL_MANAGMENT_MOBILE_BLOQUEOS:
      type = MOBILE;
      break;
    case URL_GENERAL_MANAGMENT_MOBILE_IMEI_PUK:
      type = MOBILE;
      break;
    case URL_GENERAL_MANAGMENT_INTERNET:
      type = INTENET;
      break;
    case URL_GENERAL_MANAGMENT_TV:
      type = TV;
      break;
  }
  return type;
};

export const getProductByProductId = ({ hiredProductsData, productId }) => {
  if (Array.isArray(hiredProductsData) && productId != null) {
    const product = hiredProductsData.filter(
      (item) => String(item?.productId) === String(productId)
    );
    return product;
  }
  return null;
};
